import React from 'react';

const OrbsBackground = () => {
  return (
    <div className="orbs-bg" aria-hidden="true">
      <div className="orb orb-1"></div>
      <div className="orb orb-2"></div>
      <div className="orb orb-3"></div>
      <div className="orb orb-4"></div>
      <div className="orb orb-5"></div>
    </div>
  );
};

export default OrbsBackground;


